import VIEWPOINTS from 'src/enums/viewpoints';

const initialState = () => ({
  currentView: VIEWPOINTS.DESKTOP.NAME,
});

const getters = {
  currentViewData: (state) => Object.values(VIEWPOINTS).find((item) => item.NAME === state.currentView),
  isDesktop: (state) => state.currentView === VIEWPOINTS.DESKTOP.NAME,
  isMobile: (state) => state.currentView === VIEWPOINTS.MOBILE.NAME,
};

const mutations = {
  selectView(state, view) {
    state.currentView = view;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
};
